import { useLocation, useSearchParams } from '@remix-run/react'
import { useEffect } from 'react'
import { useGetLocale } from '@hooks/useGetLocale'
import { DEFAULT_LOCALE } from '@constants/i18n'

// Client-side activation of Optimizely experiment
export function useActivateOptimizelyDecision({
  flagKey,
  attributes = {},
}: {
  flagKey?: string | null
  attributes?: Record<string, string | number | null>
}) {
  const locale = useGetLocale()
  const [searchParams] = useSearchParams()
  const { pathname } = useLocation()

  useEffect(() => {
    if (flagKey) {
      const payload = {
        decideProps: {
          flagKey,
          attributes,
        },
        attributeProps: {
          locale: locale || DEFAULT_LOCALE,
          pathname,
          searchParams: Object.fromEntries([...searchParams]),
        },
      }

      fetch('/optimizely/decide', {
        method: 'POST',
        body: JSON.stringify(payload),
      })
    }
  }, [flagKey, attributes, locale, pathname, searchParams])
}
